import { useState } from 'react';

export const useJobModals = () => {
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isJobRequestModalVisible, setIsJobRequestModalVisible] = useState(false);
    const [selectedJobIdHash, setSelectedJobIdHash] = useState(null);
    const [selectedJobId, setSelectedJobId] = useState(null);
    const [previewJrf, setPreviewJrf] = useState(false);
    const [blockSubmissionReason, setBlockSubmissionReason] = useState(null);
    const [vetsmithConfirmationModal, setVetsmithConfirmationModal] = useState(false);
    const [icfJob, setIcfJob] = useState(null);

    const showModal = () => setIsModalVisible(true);
    const hideModal = () => setIsModalVisible(false);
    
    const showJobRequestModal = () => {
        setIsJobRequestModalVisible(true);
    }
    const hideJobRequestModal = () => {
        setIsJobRequestModalVisible(false);
        setSelectedJobIdHash(null);
        setSelectedJobId(null);
        setPreviewJrf(false);
    };

    const openVetsmithConfirmationModal = () => setVetsmithConfirmationModal(true);
    const closeVetsmithConfirmationModal = () => {
        setVetsmithConfirmationModal(false);
        setIcfJob(null);
    }

    return {
        modalStates: {
            isModalVisible,
            isJobRequestModalVisible,
            selectedJobIdHash,
            selectedJobId,
            previewJrf,
            vetsmithConfirmationModal,
            icfJob,
            blockSubmissionReason
        },
        modalActions: {
            showModal,
            hideModal,
            showJobRequestModal,
            hideJobRequestModal,
            setSelectedJobIdHash,
            setSelectedJobId,
            setPreviewJrf,
            setBlockSubmissionReason,
            openVetsmithConfirmationModal,
            closeVetsmithConfirmationModal,
            setIcfJob
        }
    };
};